export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About Us",
      products: "Products",
      whyUs: "Why Us",
      compliance: "Compliance",
      faq: "FAQ",
      contact: "Contact",
    },
    hero: {
      overline: "MEDECINE SUPPLY S.A.",
      title: "Quality Disposable Medical Products for Your Health and Safety",
      subtitle: "We are a leading importer and distributor of disposable medical products. We specialize in providing reliable, high-quality solutions for healthcare professionals, hospitals, and medical centers worldwide.",
      shopNow: "View Catalog",
      requestQuote: "Request a Quote",
      contactSales: "Contact Sales",
      catalogPdf: "Download Full Catalog (PDF)",
    },
    about: {
      overline: "ABOUT MEDECINE SUPPLY",
      title: "Your Trusted Partner in Disposable Medical Products",
      description: "Welcome to Medecine Supply S.A., a leading importer and distributor of disposable medical products. We specialize in providing reliable, high-quality solutions for healthcare professionals, hospitals, and medical centers. Our commitment is to ensure the health and safety of patients and medical staff through reliable and efficient disposable products.",
      mission: {
        title: "Our Mission",
        text: "To provide healthcare providers with a wide range of high-quality disposable medical products that meet the highest quality standards and applicable regulations, ensuring patient safety at every step.",
      },
      values: {
        title: "Our Values",
        items: ["Reliability & Quality", "Patient Safety First", "Professional Support 24/7", "Continuous Innovation"],
      },
      guarantee: {
        title: "Quality Guarantee",
        text: "Every product in our catalog undergoes rigorous quality control. We offer personalized services and support to meet the individual needs of our clients.",
      },
    },
    categories: {
      overline: "PRODUCT CATEGORIES",
      title: "Wide Range of Disposable Medical Products",
      subtitle: "We offer a diverse selection of disposable medical products for various applications, from infusion therapy to surgery and diagnostics.",
      catalogLink: "View Full Catalog",
    },
    whyUs: {
      overline: "WHY CHOOSE US",
      title: "The MedecineSupply Advantage",
      reasons: [
        { title: "FDA & ISO Certified", desc: "All products meet strict regulatory standards with full documentation and traceability." },
        { title: "Global Logistics", desc: "Reliable shipping to 50+ countries with temperature-controlled supply chain management." },
        { title: "Competitive Pricing", desc: "Direct manufacturer relationships enable volume discounts up to 40% for institutional buyers." },
        { title: "24/7 Expert Support", desc: "Dedicated account managers and technical support team available around the clock." },
        { title: "Bulk Order Solutions", desc: "Custom packaging, private labeling, and flexible ordering for large-scale procurement." },
        { title: "Quality Assurance", desc: "Multi-point quality inspection process with batch tracking and recall management systems." },
      ],
    },
    products: {
      overline: "FEATURED PRODUCTS",
      title: "Our Disposable Medical Products",
      subtitle: "Discover our most trusted products, chosen by healthcare professionals worldwide. Download the full catalog for complete specifications.",
      viewDetails: "View Details",
      inStock: "Available",
      catalogPdf: "Download Full Catalog (PDF)",
      availableSizes: "Available Sizes",
      keyFeatures: "Key Features",
      techSpecs: "Technical Specifications",
      relatedProducts: "Related Products",
    },
    compliance: {
      overline: "COMPLIANCE & CERTIFICATIONS",
      title: "Meeting the Highest Industry Standards",
      subtitle: "Your trust is our priority. We maintain rigorous compliance with international healthcare regulations.",
      items: [
        { title: "FDA Compliance", desc: "All medical devices and supplies are registered and compliant with U.S. Food and Drug Administration requirements." },
        { title: "ISO 13485:2016", desc: "Our quality management system is certified to the international standard for medical device manufacturing." },
        { title: "CE Marking", desc: "Products meet European conformity requirements for safety, health, and environmental protection." },
        { title: "GMP Certified", desc: "Good Manufacturing Practice certification ensures consistent production quality and safety." },
        { title: "Supply Chain Transparency", desc: "Full traceability from manufacturer to end-user with documented chain of custody for every product." },
        { title: "HIPAA Compliant", desc: "Our data handling and customer information management meets healthcare privacy standards." },
      ],
    },
    testimonials: {
      overline: "WHAT OUR CLIENTS SAY",
      title: "Trusted by Healthcare Institutions",
      items: [
        { text: "Medecine Supply has been our primary vendor for disposable medical products for over three years. Their consistent quality in I.V. cannulas and infusion sets has made them an indispensable partner for our hospital network.", author: "Regional Hospital Network", role: "Procurement Director" },
        { text: "The personalized service and wide range of products from catheter lines to blood collection tubes have significantly streamlined our supply chain. Their support team is responsive and knowledgeable.", author: "Private Clinic Group", role: "Operations Manager" },
        { text: "We switched to Medecine Supply for our disposable product needs and the quality has been exceptional. From anaesthesia supplies to surgical drainage systems, everything arrives on time.", author: "Community Health Center", role: "Supply Chain Coordinator" },
      ],
    },
    faq: {
      overline: "FREQUENTLY ASKED QUESTIONS",
      title: "Everything You Need to Know",
      items: [
        { q: "What are your minimum order quantities?", a: "Minimum order quantities vary by product category. For most items, we offer flexible MOQs starting from a single case. Bulk orders of 10+ cases qualify for volume discounts. Contact our sales team for specific product MOQs." },
        { q: "Do you ship internationally?", a: "Yes, we ship to over 50 countries worldwide. International orders include full customs documentation, temperature-controlled shipping where required, and real-time tracking. Shipping times vary from 3-15 business days depending on destination." },
        { q: "What is your return and refund policy?", a: "We offer a 30-day return policy for unopened and undamaged products. Defective items are replaced immediately at no additional cost. All returns must include original packaging and documentation." },
        { q: "Do you offer corporate accounts?", a: "Absolutely. Corporate accounts include dedicated account managers, custom pricing tiers, NET 30/60/90 payment terms, and priority shipping. Apply through our Contact Sales form to get started." },
        { q: "Are all your products FDA approved?", a: "All applicable products in our catalog are FDA-registered and compliant. We maintain current certificates of conformity and can provide documentation upon request for any product in our inventory." },
        { q: "How do I request a custom quote?", a: "Use our Request a Quote form or contact our sales team directly. Provide product details, quantities, and delivery requirements for a customized proposal within 24 business hours." },
      ],
    },
    contact: {
      overline: "GET IN TOUCH",
      title: "Let's Start a Conversation",
      subtitle: "Whether you need a quick quote or have questions about our products, our team is here to help.",
      office: "Office",
      address: "Av Fco. de Miranda C.C Plaza",
      addressLine2: "Los Palos Grande, Municipio Chacao, Caracas",
      availability: "Availability",
      hours: {
        weekdays: "Mon-Fri: 8:00 - 21:00",
        saturday: "Sat: 8:00 - 14:00",
      },
      emailLabel: "Email",
      email: "info@medecinesupply.com",
      phoneLabel: "Phone",
      phone: "+58 212-2836328",
      form: {
        name: "Full Name",
        email: "Email Address",
        phone: "Phone Number",
        company: "Company / Institution",
        message: "Your Message",
        products: "Products of Interest",
        quantity: "Estimated Quantity",
        details: "Additional Details",
        submitContact: "Send Message",
        submitQuote: "Request Quote",
        sending: "Sending...",
        tabContact: "Contact Us",
        tabQuote: "Request Quote",
      },
    },
    footer: {
      description: "Medecine Supply S.A. - Your trusted importer and distributor of disposable medical products. Providing reliable, high-quality solutions for healthcare professionals, hospitals, and medical centers.",
      quickLinks: "Quick Links",
      categories: "Categories",
      contactInfo: "Contact Info",
      email: "info@medecinesupply.com",
      phone: "+58 212-2836328",
      address: "Av Fco. de Miranda C.C Plaza, Los Palos Grande, Municipio Chacao, Caracas",
      hours: "Mon-Fri: 8:00-21:00 | Sat: 8:00-14:00",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      refund: "Refund Policy",
      copyright: "MedecineSupply. All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      products: "Productos",
      whyUs: "Ventajas",
      compliance: "Certificaciones",
      faq: "Preguntas",
      contact: "Contacto",
    },
    hero: {
      overline: "MEDECINE SUPPLY S.A.",
      title: "Productos Medicos Descartables de Calidad para su Salud y Seguridad",
      subtitle: "Somos un importante importador y distribuidor de productos medicos descartables. Nos especializamos en brindar soluciones confiables y de alta calidad para profesionales de la salud, hospitales y centros medicos.",
      shopNow: "Ver Catalogo",
      requestQuote: "Solicitar Cotizacion",
      contactSales: "Contactar Ventas",
      catalogPdf: "Descargar Catalogo Completo (PDF)",
    },
    about: {
      overline: "SOBRE MEDECINE SUPPLY",
      title: "Su Socio de Confianza en Productos Medicos Descartables",
      description: "Bienvenido a Medecine Supply S.A., un importante importador y distribuidor de productos medicos descartables. Nos especializamos en brindar soluciones confiables y de alta calidad para profesionales de la salud, hospitales y centros medicos. Nuestro compromiso es garantizar la salud y seguridad de los pacientes y del personal medico a traves de productos descartables confiables y eficientes.",
      mission: {
        title: "Nuestra Mision",
        text: "Proporcionar a los proveedores de salud una amplia gama de productos medicos descartables de alta calidad que cumplan con los mas altos estandares y la normativa aplicable, garantizando la seguridad del paciente.",
      },
      values: {
        title: "Nuestros Valores",
        items: ["Confiabilidad y Calidad", "Seguridad del Paciente", "Soporte Profesional 24/7", "Innovacion Continua"],
      },
      guarantee: {
        title: "Garantia de Calidad",
        text: "Cada producto en nuestro catalogo pasa por un riguroso control de calidad. Ofrecemos servicios personalizados y apoyo para satisfacer las necesidades individuales de nuestros clientes.",
      },
    },
    categories: {
      overline: "CATEGORIAS DE PRODUCTOS",
      title: "Amplia Gama de Productos Medicos Descartables",
      subtitle: "Ofrecemos una diversa seleccion de productos medicos descartables para diversas aplicaciones, desde terapia de infusion hasta cirugia y diagnostico.",
      catalogLink: "Ver Catalogo Completo",
    },
    whyUs: {
      overline: "POR QUE ELEGIRNOS",
      title: "La Ventaja MedecineSupply",
      reasons: [
        { title: "Certificados FDA e ISO", desc: "Todos los productos cumplen estrictos estandares regulatorios con documentacion completa y trazabilidad." },
        { title: "Logistica Global", desc: "Envios confiables a mas de 50 paises con cadena de suministro con control de temperatura." },
        { title: "Precios Competitivos", desc: "Relaciones directas con fabricantes permiten descuentos por volumen de hasta 40% para compradores institucionales." },
        { title: "Soporte Experto 24/7", desc: "Gerentes de cuenta dedicados y equipo de soporte tecnico disponibles las 24 horas." },
        { title: "Pedidos al Por Mayor", desc: "Empaque personalizado, etiquetado privado y pedidos flexibles para adquisiciones a gran escala." },
        { title: "Control de Calidad", desc: "Proceso de inspeccion de calidad multipunto con seguimiento de lotes y sistemas de gestion de retiros." },
      ],
    },
    products: {
      overline: "PRODUCTOS DESTACADOS",
      title: "Nuestros Productos Medicos Descartables",
      subtitle: "Descubra nuestros productos mas confiables, elegidos por profesionales de la salud. Descargue el catalogo completo para especificaciones detalladas.",
      viewDetails: "Ver Detalles",
      inStock: "Disponible",
      catalogPdf: "Descargar Catalogo Completo (PDF)",
      availableSizes: "Tamanios Disponibles",
      keyFeatures: "Caracteristicas Principales",
      techSpecs: "Especificaciones Tecnicas",
      relatedProducts: "Productos Relacionados",
    },
    compliance: {
      overline: "CUMPLIMIENTO Y CERTIFICACIONES",
      title: "Cumpliendo los Mas Altos Estandares",
      subtitle: "Su confianza es nuestra prioridad. Mantenemos un riguroso cumplimiento con regulaciones internacionales.",
      items: [
        { title: "Cumplimiento FDA", desc: "Todos los dispositivos y suministros medicos estan registrados y cumplen con los requisitos de la FDA." },
        { title: "ISO 13485:2016", desc: "Nuestro sistema de gestion de calidad esta certificado bajo el estandar internacional para fabricacion de dispositivos medicos." },
        { title: "Marcado CE", desc: "Los productos cumplen los requisitos europeos de seguridad, salud y proteccion ambiental." },
        { title: "Certificacion GMP", desc: "La certificacion de Buenas Practicas de Manufactura asegura calidad y seguridad consistentes." },
        { title: "Transparencia en Cadena", desc: "Trazabilidad completa del fabricante al usuario final con custodia documentada para cada producto." },
        { title: "Cumplimiento HIPAA", desc: "Nuestro manejo de datos e informacion cumple los estandares de privacidad en salud." },
      ],
    },
    testimonials: {
      overline: "LO QUE DICEN NUESTROS CLIENTES",
      title: "Confianza de Instituciones de Salud",
      items: [
        { text: "Medecine Supply ha sido nuestro proveedor principal de productos medicos descartables por mas de tres anos. Su calidad consistente en canulas IV y sets de infusion los hacen un socio indispensable.", author: "Red Hospitalaria Regional", role: "Director de Adquisiciones" },
        { text: "El servicio personalizado y la amplia gama de productos, desde lineas de cateteres hasta tubos de recoleccion de sangre, han optimizado nuestra cadena de suministro.", author: "Grupo de Clinicas Privadas", role: "Gerente de Operaciones" },
        { text: "Cambiamos a Medecine Supply para nuestras necesidades de productos descartables y la calidad ha sido excepcional. Desde suministros de anestesia hasta sistemas de drenaje, todo llega a tiempo.", author: "Centro de Salud Comunitario", role: "Coordinador de Suministros" },
      ],
    },
    faq: {
      overline: "PREGUNTAS FRECUENTES",
      title: "Todo lo que Necesita Saber",
      items: [
        { q: "Cuales son las cantidades minimas de pedido?", a: "Las cantidades minimas varian por categoria. Para la mayoria, ofrecemos cantidades flexibles desde una sola caja. Pedidos de 10+ cajas califican para descuentos por volumen." },
        { q: "Realizan envios internacionales?", a: "Si, enviamos a mas de 50 paises. Los pedidos internacionales incluyen documentacion aduanera completa, envio con control de temperatura y seguimiento en tiempo real." },
        { q: "Cual es su politica de devoluciones?", a: "Ofrecemos devolucion en 30 dias para productos sin abrir y sin dano. Los articulos defectuosos se reemplazan inmediatamente sin costo adicional." },
        { q: "Ofrecen cuentas corporativas?", a: "Por supuesto. Las cuentas corporativas incluyen gerente de cuenta dedicado, precios personalizados, terminos de pago NET 30/60/90 y envio prioritario." },
        { q: "Todos sus productos tienen aprobacion FDA?", a: "Todos los productos aplicables en nuestro catalogo estan registrados y cumplen con la FDA. Mantenemos certificados vigentes y podemos proporcionar documentacion a solicitud." },
        { q: "Como solicito una cotizacion personalizada?", a: "Use nuestro formulario de Solicitar Cotizacion o contacte a nuestro equipo de ventas directamente. Proporcione detalles del producto, cantidades y requisitos de entrega." },
      ],
    },
    contact: {
      overline: "CONTACTENOS",
      title: "Iniciemos una Conversacion",
      subtitle: "Ya sea que necesite una cotizacion rapida o tenga preguntas sobre nuestros productos, nuestro equipo esta aqui para ayudar.",
      office: "Oficina",
      address: "Av Fco. de Miranda C.C Plaza",
      addressLine2: "Los Palos Grande, Municipio Chacao, Caracas",
      availability: "Disponibilidad",
      hours: {
        weekdays: "Lun-Vie: 8:00 - 21:00",
        saturday: "Sab: 8:00 - 14:00",
      },
      emailLabel: "Correo",
      email: "info@medecinesupply.com",
      phoneLabel: "Telefono",
      phone: "+58 212-2836328",
      form: {
        name: "Nombre Completo",
        email: "Correo Electronico",
        phone: "Telefono",
        company: "Empresa / Institucion",
        message: "Su Mensaje",
        products: "Productos de Interes",
        quantity: "Cantidad Estimada",
        details: "Detalles Adicionales",
        submitContact: "Enviar Mensaje",
        submitQuote: "Solicitar Cotizacion",
        sending: "Enviando...",
        tabContact: "Contactenos",
        tabQuote: "Solicitar Cotizacion",
      },
    },
    footer: {
      description: "Medecine Supply S.A. - Su importador y distribuidor de confianza de productos medicos descartables. Brindando soluciones confiables y de alta calidad para profesionales de la salud, hospitales y centros medicos.",
      quickLinks: "Enlaces Rapidos",
      categories: "Categorias",
      contactInfo: "Informacion de Contacto",
      email: "creyes@technolrg.com",
      phone: "+1 (800) 555-0199",
      address: "Distrito Medico, Suite 400",
      legal: "Legal",
      privacy: "Politica de Privacidad",
      terms: "Terminos de Servicio",
      refund: "Politica de Reembolso",
      copyright: "MedecineSupply. Todos los derechos reservados.",
    },
  },
};
